<div class="container-fluid order-review">
  <div class="row mb-4">
    <div class="col-lg-8 col-sm-8 col-md-8 padding_0 align_self">
      <div class="left-content">
        <div class="sub-title">
          {{ "orderCheckOut.orderSubTitle" | cxTranslate }}:
          <strong class="valueTxt">{{ printShippingMethod() }}</strong>
          <!-- <a (click)="editCartLink()" class="ml-2 change-text">Change</a> -->
        </div>
        <!-- <div class="sub-title">{{ "orderCheckOut.reqShipdate" | cxTranslate }}: <strong> {{fetchedCartReviewOrder?.customerRequestedDate}}</strong></div> -->

        <div class="sub-title">
          {{ "orderCheckOut.orderType" | cxTranslate }}:
          <strong class="valueTxt">{{
            fetchedCartReviewOrder?.cartOrderType?.name
          }}</strong>
          <div class="download tp-6" (click)="downloadPdf()">
            <i class="material-icons-outlined mr-2">save_alt</i>
            <span>{{ "orderCheckOut.DOWNLOADPDF" | cxTranslate }}</span>
          </div>
        </div>
        <div class="sub-title mb_0">
          {{ "orderCheckOut.commissionEligible" | cxTranslate }} :
          <strong class="valueTxt">{{
            isCommissionEligible ? "Yes" : "No"
          }}</strong>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-sm-4 col-md-4 pl82 mt-20">
      <div class="row cart-cost">
        <div class="col-lg-6 col-sm-6 col-md-6 right-content padding_0">
          <div class="sub-title">
            {{ "orderCheckOut.subTotal" | cxTranslate }}
          </div>
          <div class="sub-title">
            {{ "orderCheckOut.couponDiscount" | cxTranslate }}
          </div>
          <div class="sub-title">
            {{ "orderCheckOut.surcharge" | cxTranslate }}
            <i class="material-icons custom-info-icon">info</i>
          </div>
          <div class="sub-title" *ngIf="hideTrasnportion">
            {{ "orderCheckOut.transportation" | cxTranslate }}
          </div>
          <div class="cart-total">
            {{ "orderCheckOut.cartTotal" | cxTranslate }} ({{
              fetchedCartReviewOrder?.totalItems
            }}
            {{ "orderCheckOut.items" | cxTranslate }}):
          </div>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 right-content padding_0">
          <div class="cost">
            {{ fetchedCartReviewOrder?.vsSubTotal?.currencyIso }}
            {{ fetchedCartReviewOrder?.vsSubTotal?.formattedValue }}
          </div>
          <div class="cost">
            {{ fetchedCartReviewOrder?.orderDiscounts?.currencyIso }}
            {{ getCouponDiscout() }}
          </div>
          <div class="cost">
            {{ fetchedCartReviewOrder?.surCharge?.currencyIso }}
            {{ fetchedCartReviewOrder?.surCharge?.formattedValue }}
          </div>
          <div class="cost" *ngIf="hideTrasnportion">
            {{ fetchedCartReviewOrder?.transportationCost?.currencyIso }}
            {{ fetchedCartReviewOrder?.transportationCost?.formattedValue }}
          </div>

          <div class="cart-total">
            {{ fetchedCartReviewOrder?.totalPrice?.currencyIso }}
            {{ fetchedCartReviewOrder?.totalPrice?.formattedValue }}
          </div>
        </div>

        <button [disabled]="orderStatus"
          (click)="openOrderReviewModal()"
          class="vs-primary-btn sample-btn proceedBtn"
        >
          <span>{{ "orderCheckOut.submitOrderBtn" | cxTranslate }}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="row mt-20">
    <div class="sub-content">
      <div class="content-title">
        <div class="header">
          {{ "orderCheckOut.addressDetails" | cxTranslate }}
          <span class="edit-link">
            <a (click)="checkoutLink()">{{ "orderCheckOut.editAddress" | cxTranslate }}</a>
          </span>
        </div>
      </div>
      <vs-address-detail></vs-address-detail>
    </div>
    <div class="sub-content">
      <div class="content-title">
        <div class="header">
          {{ "orderCheckOut.lineItems" | cxTranslate }}
          <span class="edit-link">
            <a (click)="editCartLink()">{{ "orderCheckOut.editInCart" | cxTranslate }}</a></span
          >
        </div>
      </div>
      <vs-line-item></vs-line-item>
    </div>
    <div class="sub-content">
      <div class="content-title">
        <div class="header">{{ "orderCheckOut.notiAndAttachement" | cxTranslate }}</div>
      </div>
      <vs-notification></vs-notification>
    </div>
    <div class="sub-content">
      <div class="content-title">
        <div class="header">{{ "orderCheckOut.shippingMethods" | cxTranslate }}</div>
      </div>
      <vs-shiping></vs-shiping>
    </div>
    <!-- Condition to show/hide Export Compliance Questionnaire - removed after UAT
            *ngIf="fetchedCartReviewOrder?.endUserAddress?.country?.isocode != legalCountry" 
        -->
    <div class="sub-content">
      <div class="content-title">
        <div class="header">{{ "orderCheckOut.questionnaire" | cxTranslate }}</div>
      </div>
      <div class="section-login">
        <!--Questions-->
        <div
          *ngFor="let questionExp of vsExportComplianceQuestions; let i = index"
          class="mb-15"
        >
          <span class="question-text">{{ i + 1 }} . </span
          ><span [innerHTML]="questionExp.question" class="question-text">
            <!-- <strong *ngIf="questionExp?.questionId == 'true' ? 'Yes':'No' "></strong> -->
            <!-- <strong *ngIf="questionExp?.questionId">Yes</strong> 
                    <strong *ngIf="!questionExp?.questionId">No</strong> -->
          </span>
          <br />
          <strong class="question-text"
            >-
            {{
              fetchedCartReviewOrder[questionExp?.questionId] == true
                ? "Yes"
                : "No"
            }}</strong
          >
          <div
            *ngIf="
              fetchedCartReviewOrder[questionExp?.questionId] == true &&
              questionExp?.questionId == 'warningFlags'
            "
            class="warning-text-flag"
          >
            {{ fetchedCartReviewOrder?.warningFlagText }}
          </div>
        </div>
        <!--Questions-->
      </div>
    </div>
    <div class="sub-content">
      <div class="content-title">
        <div class="header">{{ "orderCheckOut.billingDetails" | cxTranslate }}</div>
      </div>
      <vs-billing-details [placeOrderStatus]="orderStatus" [isAdditionalType]="fetchedCartReviewOrder.isAdditionalType"></vs-billing-details>
    </div>
  </div>
</div>
